/**
 * The account last signed in on this browser (2026-10-21, gift send flow
 * R4.35). The app keeps it through a sign-out (`qid`), so when the sender
 * opens his own gift link signed out, the server knows it is his browser: not
 * an open, and the link is not taken. It only ever takes something away, so
 * the server never gives this browser anything a sign-in would.
 */
export function browserAccount (storage = (typeof localStorage !== 'undefined' ? localStorage : null)) {
  try {
    return (storage && (storage.getItem('querent_id') || storage.getItem('qid'))) || ''
  } catch (e) { return '' }
}

/** "Not <Sender>? Open it here.": someone else on a shared browser. */
export function forgetBrowserAccount (storage = (typeof localStorage !== 'undefined' ? localStorage : null)) {
  try { storage && storage.removeItem('qid') } catch (e) { /* */ }
}

/** { device } for a request body, or nothing when this browser has had no account. */
export function withDevice (storage) {
  const device = browserAccount(storage)
  return device ? { device } : {}
}
